<template>
	<m-layout>
    <div fill-height class="fill-height" style="width:100%">
      <m-confirm ref="confirm"></m-confirm>
      <m-route-map ref="routeMap"></m-route-map>
      <m-booking-add-form :form="form" :booking="selectedItem" :dialog="dialog_booking" @save="onSaveBooking" @close="onCloseBooking" @refresh="onRefresh"></m-booking-add-form>
      <m-booking-edit-form :form="form" :booking="selectedItem" :dialog="dialog_edit" @refresh="onRefresh" @update="onUpdateBooking" @close="onCloseBooking"></m-booking-edit-form>



      <v-toolbar flat class="pt-2 tm-toolbar" height="30px">
        <!-- <span class="headline">Timeline</span> -->
                   <v-menu
                        :close-on-content-click="false"
                        v-model="menu_date"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                      >
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="primary--text" icon>
                          <v-icon>event</v-icon>
                        </v-btn>
                        </template>
                        <v-date-picker v-model="form.ap_date" scrollable @input="dateFormatted = formatDate($event)" @change="moveDate"></v-date-picker>

                  </v-menu>
                          <m-search :items="bookings" @search="moveToId"></m-search>
                          <v-spacer></v-spacer>

                          <v-select
                            prepend-icon="directions_car"
                            v-model="selectedDrivers"
                            :items="groups"
                            item-text="name"
                            item-value="id"
                            return-object
                            label="Select Driver"
                            multiple
                            single-line
                            style="max-width: 180px"
                            @change="onChangeDrivers"
                            hideDetails
                            dense
                          >
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @click="toggleSelectAll"
                          >
                            <v-list-item-action>
                              <v-icon :color="isAllSelected ? 'primary' : ''">
                                directions_car
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title :color="isAllSelected ? 'primary' : ''">
                                {{ isAllSelected ? 'Clear' : 'Select All' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>

                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index === 0" small>
                                <span>{{ selectedDrivers.length }} drivers</span>
                              </v-chip>
                            </template>
                          </v-select>

                          <!-- // filter drivers // -->
                          <!--
                            <v-text-field
                              class="pt-0 ml-3"
                              prepend-icon="directions_car"
                              label="Filter driver..."
                              single-line
                              hide-details
                              v-model="search"
                              style="max-width: 180px"
                            ></v-text-field>
                            -->
                            <v-spacer></v-spacer>

                      <v-btn class="primary--text" icon @click="moveTimeline(0.5)">
                        <v-icon>arrow_back</v-icon>
                      </v-btn>
                      <v-btn class="primary--text" icon @click="moveTimeline(-0.5)">
                        <v-icon>arrow_forward</v-icon>
                      </v-btn>
                      <v-btn class="primary--text" icon @click="zoomIn">
                        <v-icon>zoom_in</v-icon>
                      </v-btn>
                      <v-btn class="primary--text" icon @click="zoomOut">
                        <v-icon>zoom_out</v-icon>
                      </v-btn>
                      <v-btn class="primary--text" icon @click="moveNow">
                        <v-icon>my_location</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="onRefresh">
                        <v-icon color="primary">refresh</v-icon>
                      </v-btn>
                          <v-dialog
                            v-model="dialog_check"
                            fullscreen
                            hide-overlay
                            transition="dialog-bottom-transition"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                              color="primary"
                              elevation="0" v-bind="attrs" v-on="on"> <v-icon left>list_alt</v-icon> check</v-btn>
                            </template>

                            <v-toolbar dark color="primary">

                              <v-toolbar-title><v-icon>list_alt</v-icon> Distance check</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <m-e-search global solo hide-details></m-e-search>
                              <v-spacer></v-spacer>
                              <v-btn icon dark @click="dialog_check = false">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-toolbar>
                            <m-distance></m-distance>
                          </v-dialog>


      </v-toolbar>

            <v-layout class="mt-4" wrap>
                    <v-flex xs12 md4>

                    </v-flex>
                    <v-flex xs12 md4>

                    </v-flex>
                    <v-flex xs12 md4>

                    </v-flex>
            </v-layout>




      <div style="width:100%">
          <m-timeline  v-if="timelineReady" class="tm-line mt-2" ref="timeline"
              @select="onSelect"
              @double-click="onDoubleClick"
              :items="timelineBookings"
              :groups="groupsFiltered"
              :options="options">
          </m-timeline>
      </div>
    </div>
	</m-layout>
</template>

<script>
import moment from 'moment';
import TimelineMixin from '@/mixins/timeline'
import MSearch from '@/components/search/search'
import eMSearch from '@/components/search/e-search'
import RouteMap from '@/components/googlemaps/routeMap'
import DistanceCheck from '@/components/booking/distance_check'

export default {
  name: 'mytimeline',
  mixins: [TimelineMixin],
  components: {
    'm-search': MSearch,
    'm-e-search': eMSearch,
    'm-distance': DistanceCheck,
    'm-route-map': RouteMap
  },
  data () {
    return {
      dialog_check: false,
      menu_date: false,
      timeline: null,
      selectedDate: moment().format('YYYY-MM-DD'),
      disabledDates: date => {
        const day = date.getDay();
        return day === 6 || day === 0;
      },
      // drivers: [],
      groups: [],
      items: [],
      // bookings: [],
      // oldData: [],
      // diffData: [],
      // initData: false,
      options: {
        orientation: 'both',
        start: moment().subtract(2, 'hours'),
        end: moment().add(10, 'hours'),
        editable: true,
        locale: 'fr',
        groupOrder: 'zones',
        showCurrentTime: true,
        onUpdate: this.onUpdateTimeline,
        onMove: this.onMove,
        onAdd: this.onAdd,
        onRemove: this.onRemove
      },
      timeBefore: 900,
      search: '',
      selectedDrivers: []
    };
  },
  methods: {
    moveToId (item) {
      // console.log(item)
      var timeline = this.$refs.timeline;
      if (item.id) {
        timeline.focus(item.id);
      } else {
        console.log('booking not in timeline');
      }
    },
    moveDate (v) {
      var timeline = this.$refs.timeline;
      this.selectedDate = v
      var start = moment(v).add(6, 'hours');
      var end = moment(v).add(20, 'hours');
      timeline.setWindow(start, end);
      this.menu_date = false;
    },
    zoomIn () {
      this.$refs.timeline.zoomIn(0.2);
    },
    zoomOut () {
      this.$refs.timeline.zoomOut(0.2);
    },
    moveNow () {
      var timeline = this.$refs.timeline;
      var start = moment().subtract(1, 'hours');
      var end = moment().add(4, 'hours');
      timeline.setWindow(start, end);
    },
    moveTimeline (percentage) {
      var timeline = this.$refs.timeline;
      var range = timeline.getWindow();
      var interval = range.end - range.start;

      timeline.setWindow(
        (range.start.valueOf() - interval * percentage),
        (range.end.valueOf() - interval * percentage)
      );
    },
    getBookingsByDriver (id, date) {
      this.$http
      .post('service/driver/byname/' + id, {ap_date: date})
      .then(response => {
        if (response.data.length) {
          var trips = [response.data[0].driver_fullAddress];
          response.data.forEach((trip) => {
            if (trip.type === 'to') {
              // console.log('getBookings data', trip);
              trips.push(trip.client_fullAddress)
              trips.push(trip.destination_fullAddress)
            } else {
              trips.push(trip.destination_fullAddress)
              trips.push(trip.client_fullAddress)
            }
          })
          this.$refs.routeMap.show(trips, true);

        }
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },

    openMap (data) {
      console.log('trips', data)
    },
    calcTimes (booking, distance) {
      var d = distance[booking.type];
      var tempStart = 0;
      var start = 0;
      var end = 0;

      if (booking.type === 'simple') {
        tempStart += d[0].duration.value + d[1].duration.value + this.timeBefore;
        start = moment(booking.ap_date + ' ' + booking.ap_time, 'DD/MM/YYYY HH:mm:ss').subtract(tempStart, 's');
        end = moment(start).add(distance.totals[booking.type].duration, 's').add(this.timeBefore, 's').add(booking.waiting, 's');
      } else if(booking.type === 'back'){
        tempStart += d[1].duration.value + d[0].duration.value;
        start = moment(booking.ap_date + ' ' + booking.ap_time, 'DD/MM/YYYY HH:mm:ss');
        end = moment(start).add(tempStart, 's').add(booking.waiting, 's');
      } else {
        tempStart += d[1].duration.value + this.timeBefore;
        start = moment(booking.ap_date + ' ' + booking.ap_time, 'DD/MM/YYYY HH:mm:ss').subtract(tempStart, 's')
        end = moment(start).add(tempStart, 's').add(this.timeBefore, 's').add(booking.waiting, 's');
      }

      return {
        start: start,
        end: end
      }
    },
    onSelect (e) {
      var id = e;
      // console.log('timeline selected', id);
    },
    onDoubleClick (e) {
      if (e.what === 'group-label') {
        // console.log('timeline clicked', e.group, this.selectedDate);
        this.getBookingsByDriver(e.group, this.selectedDate);
      }
    },
    onUpdateTimeline (e) {
      // console.log('doubleclick timeline onUpdateTimeline', e);
      var id = e.id;
      var app = this;
      // console.log('timeline selected', id);
      this.getBooking(id, function (booking) {
        app.selectedItem = booking;
        app.dialog_edit = true;
        // console.log('selected booking', booking);
      })
    },
    onMove (item) {
      console.log('------ timeline onMove ---------');
      console.log('item.id: ', item.id);
      console.log('item.start: ', item.start);
      console.log('item.end: ', item.end);
    },
    onAdd (item) {
      var date = moment(item.start)
      this.selectedItem = {
        ap_date: date.format('DD/MM/YYYY'),
        ap_time: date.format('HH:mm'),
        dates: [date.format('YYYY-MM-DD')],
        driverId: item.group
      };
      // console.log('timeline onAdd:', this.selectedItem)
      this.dialog_booking = true
    },
    onRemove (item, callback) {
      this.$refs.confirm.open('Delete', 'Delete ' + item.id + ' - are you sure?', { persistent: true }).then((confirm) => {
        if (confirm) {
          this.deleteBooking(item, callback);
        }
      });
    },
    onChangeDrivers (item) {
      console.log('onChangeDrivers', item);
    },
    toggleSelectAll () {
      this.$nextTick(() => {
        if (this.isAllSelected) {
          this.selectedDrivers = [];
        } else {
          this.selectedDrivers = this.groups.slice();
        }
      })
    },
    update (app) {
      this.updateBookings(app);
      // app.$refs.timeline.on('dubbleClick', this.doubleClick);
      // console.log('timeline data', app.items);
    }
  },
  computed: {
    groupsFiltered () {
      // console.log('search');
      return this.selectedDrivers.filter(item => {
        if (!this.search) return this.groups;
        return (
          item.name.toLowerCase().includes(this.search.toLowerCase()) || item.id.toString().includes(this.search.toLowerCase())
        );
      });
    },
    isAllSelected () {
      return this.selectedDrivers.length === this.groups.length;
    }
  }
}
</script>

<style lang="scss">


  .tm-toolbar {
    &.v-toolbar {
      background-color: transparent !important;
    }
  }
  .md-field {
    max-width: 400px;
  }
  .md-with-icon {
    position: relative;
    display: flex;
    > i {
      margin-right: 0.3em;
    }
  }
  .md-datepicker-dialog,
  .md-menu-content {
    background-color: #fff;
  }
  .item-container {
    padding: 2px;
    .group-name {
      color: #000;
    }
  }
  .tm-line {
    margin-top: 0px;

  .vis-timeline {
    border: 1px solid #ccc;
    font-size: 15px;
    padding-top: 20px;
    padding-right: 20px;
    .vis-odd{
      background-color: rgba(236, 236, 236, 0.2);
    }
  }
  div.vis-tooltip {
    background-color: #f5f5f5;
    border-color: #aaa;
    font-size: 12px;
  }

  .vis-item {
    font-size: 12px;
    // color: rgba(229, 57, 53, 1);
    border-color: #a8a6a6;
    // background-color: rgba(163, 161, 161, 0.2);
    border-radius: 0;
    .vis-delete:hover {
      background: none;
      &:after{
        color: rgba(229, 57, 53, 1);
      }
    }

  }

  .vis-item.vis-range {
    border-radius: 0;
  }
  .vis-item .vis-item-content {
    padding: 2px;
  }
  .vis-label .vis-inner {
    width: 100%;
  }
  .vis-item,
  .vis-item.vis-line {
    border-width: 1px;
  }

  .vis-item.vis-dot {
    border-width: 10px;
    border-radius: 0;
  }

  .vis-item.vis-selected {
    border-radius: 0;
    background-color: rgba(229, 57, 53, 1);
  }
  .vis-item .vis-delete:after {
    color: $primary;
  }

  .vis-time-axis .vis-text {
    color: rgb(53, 52, 52);
  }

  .vis-time-axis .vis-text.vis-major {
    color: rgb(71, 70, 70);
    font-weight: bold;
  }

  .vis-time-axis .vis-grid.vis-minor {
    border-width: 1px;
  }

  .vis-time-axis .vis-grid.vis-major {
    border-width: 2px;
    border-color: black;
  }

  .vis-item.backclass {
    // border-color: rgb(51, 50, 50);
    color: $primary;
    background-color: rgba($primary, .2);

    // background-color: rgba(229, 57, 53, 0.2);
  }
  .vis-item.toclass {
    color: $primary;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .vis-item.simpleclass {
    color: $primary;
    background-color: #d5ddf6;
  }
  .vis-item.chargedClass::after {
        font-family: 'Material Icons';
        position: absolute;
        font-size: 20px;
        font-weight: bold;
        bottom: -6px;
        left: -22px;
        content: "\e7fd";
        color: rgb(180, 177, 177);

  }

  .vis-item.statusClass::after {
    font-family: 'Material Icons';
    position: absolute;
    font-size: 16px;
    font-weight: bold;
    bottom: -4px;
    left: -18px;
    content: "\e897";
  }

  .vis-item.statusClass {
    &.status-1::after{
      color: rgba(32, 151, 2, 1) !important;
    }
    .status-2::after {
      color:rgba(248, 1, 1, 1) !important;
    }
    .status-3::after {
      color:rgb(150, 148, 148) !important;
    }
  }

  .vis-item.acceptedClass {

    &-1 {
      .item-container {
        opacity: .5;
      }
      &::before {
        position: absolute;
        font-size: 18px;
        font-weight: bold;
        left: -12px;
        content: "\003F";
        color: rgb(143, 142, 142);
      }
    }
    &-2 {
      &::before {
        position: absolute;
        font-size: 18px;
        left: -16px;
        content: "\2713";
        color: rgb(7, 160, 15);
      }
    }
    &-3 {
      // border-color: red;
      .item-container {
        opacity: .4;
      }

      &::before {
        position: absolute;
        font-size: 18px;
        font-weight: bold;
        left: -10px;
        content: "\0021";
        color: $primary;
      }
    }
    &-4 {
      // border-color: red;
      .item-container {
        opacity: .4;
      }

      &::before {
        font-family: 'Material Icons';
        position: absolute;
        font-size: 18px;
        font-weight: bold;
        left: -20px;
        content: "\e8b5";
        color: rgba($primary, .6);
      }
    }
  }
  .vis-label {
    border-right: solid 3px white;
    &.zone {
      &-0 { border-right-color:rgb(192, 189, 189); background-color: rgba(207, 204, 204, 0.1);}
      &-1 { border-right-color:rgb(31, 177, 44); background-color: rgba(55, 213, 92, 0.1);}
      &-2 { border-right-color:rgb(240, 218, 20); background-color: rgba(240, 218, 20, 0.1);}
      //schaarbeek
      &-3 { border-right-color:rgb(215, 3, 3); background-color: rgba(213, 30, 30, 0.2);}

      &-4 { border-right-color:rgb(25, 25, 201); background-color: rgba(58, 182, 240, 0.1);}
      &-5 { border-right-color:rgb(25, 25, 201); background-color: rgba(20, 157, 220, 0.3);}
      &-6 { border-right-color:rgb(254, 162, 2); background-color: rgba(226, 149, 6, 0.1);}
      &-7 { border-right-color:rgb(215, 3, 3); background-color: rgba(213, 30, 30, 0.1);}

    }
  }
  .vis-item {
    .insurance::after {
      content: "hello";
    }

    .motive {
      &-4, &-5, &-6 {}
    }
    .v-icon {
      font-size: 14px;
      display: none;
      &.status {
        &-0 {}
        &-1 {
          display: inline-block;
          color: rgba(32, 151, 2, 1) !important;
        }
        &-2 {
          display: inline-block;
          color:rgba(248, 1, 1, 1) !important;
        }
        &-3 {
          display: inline-block;
          color:rgb(150, 148, 148) !important;
        }
      }

      &.noinsurance {
        display: inline-block;
        color:rgb(150, 148, 148) !important;
      }
    }
    .accepted {
      position: absolute;
      .v-icon {
        font-size: 14px;
        display: block;
      }
      &.accepted {
        &-0 {}
        &-1 {
          color: rgba(32, 151, 2, 1) !important;
        }
        &-2 {
          color:rgba(248, 1, 1, 1) !important;
        }
        &-3 {
          color:rgb(150, 148, 148) !important;
        }
      }
    }
  }
  .vis-item.vis-background {
    background-color:rgba(250, 171, 169, 0.1);
  }
  .vis-current-time {
    background-color: $primary;
  }
  }
  .invoiceAddress {
    border: solid 1px #eee;
    padding: 0 20px 20px;
    .invoice-label {
      padding-top: 10px;
      color: #ccc;
    }
  }
</style>

